/* eslint-disable max-len */
/* global Swiper */
// **************************************************
// 1.0 - Gallery
// **************************************************


window.addEventListener('spectoCmsContentLoaded', () => {
  window.galleryModalElements = document.querySelectorAll('[data-slider="gallery-popup-slider"]');
  window.gallerySections = document.querySelectorAll('.sc-gallery');
  window.galleryModals = [];
  window.getGalleryIndex = (galleryToFind) => Array.from(gallerySections).findIndex((el) => el === galleryToFind);

  window.galleryModalOptions = {
    slidesPerView: 1,
    spaceBetween: 0,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: '.arrow-left',
      prevEl: '.arrow-right',
    },
  };

  galleryModalElements.forEach((el) => {
    const galleryPopup = el.closest('.gallery-popup');
    const arrowRight = galleryPopup.querySelector('.arrow-right');
    const arrowLeft = galleryPopup.querySelector('.arrow-left');

    galleryModalOptions.navigation.nextEl = arrowRight;
    galleryModalOptions.navigation.prevEl = arrowLeft;
    galleryModals.push(new Swiper(el, galleryModalOptions));

    document.querySelectorAll('.gallery-popup__close').forEach((galleryClose) => {
      galleryClose.addEventListener('click', () => {
        galleryPopup.classList.remove('is-open');
      });
    });

    const galleryImgs = document.querySelectorAll('.gallery__item-img');
    galleryImgs.forEach((galleryImg) => {
      galleryImg.addEventListener('click', () => {
        const index = getGalleryIndex(galleryImg.closest('.sc-gallery'));
        const galleryPop = galleryImg.closest('.sc-gallery').querySelector('.gallery-popup');
        const targetSlide = galleryImg.getAttribute('data-modalslide');
        galleryModals[index].slideTo(targetSlide - 1, 0);

        galleryPop.classList.add('is-open');
      });
    });
  });
});
